import { render, staticRenderFns } from "./StorageInKu.vue?vue&type=template&id=6cb29635&scoped=true&"
import script from "./StorageInKu.vue?vue&type=script&lang=js&"
export * from "./StorageInKu.vue?vue&type=script&lang=js&"
import style0 from "./StorageInKu.vue?vue&type=style&index=0&id=6cb29635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb29635",
  null
  
)

export default component.exports